export enum EnumSolicitacaoCompraFornecedorStatus {
	ABERTO, 
    FECHADO
}